import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import shortid from "shortid";
import swal from "sweetalert2";
import { isEmpty, isNumeric, isEmail } from "validator";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  changeStep,
  validateInputArray,
  updateRegistrationData,
  resetRegistration,
  saveAsDraft,
  updateAttachment,
} from "../actions";
import { validateNRIC } from "../../../../utils/common";
import BeneficiaryForm from "./BeneficiaryForm";

class Tab3 extends React.Component {
  constructor(props) {
    super(props);

    const tab3Compiled = props.tab3
      ? props.tab3.map((ob) => ({
          ...ob,
          Date_of_Birth__c: moment(ob.Date_of_Birth__c),
          RecordTypeId: props.recordType.Beneficiary,
        }))
      : [
          {
            shortid: shortid(),
            RecordTypeId: props.recordType.Beneficiary,
          },
        ];
    this.state = {
      form: tab3Compiled,
      errorMessage: [],
      attachment: props.attachment || [],
    };
    this.onInputChanged = this.onInputChanged.bind(this);
    // this.onBlurValidation = this.onBlurValidation.bind(this);
    this.onFileUploaded = this.onFileUploaded.bind(this);
    this.validateInputArray = validateInputArray.bind(this);
    this.validationList = this.validationList.bind(this);
    this.removeBeneficiary = this.removeBeneficiary.bind(this);
    this.onRemoveFile = this.onRemoveFile.bind(this);
  }

  componentWillMount() {
    if (this.props.tab2 === null) window.location = "/portal/registration-v2/";
    this.props.changeStep(2);
  }

  async onFileUploaded(e) {
    e.preventDefault();
    const { attachment } = this.state;
    const { name } = e.target;
    const names = name.split(".");
    if (e.target.files[0] !== undefined) {
      const prefixFile = "Nric_Fin_";
      const file = e.target.files[0];
      const originalFileName = file.name.replace(/ |-/g, "_");
      const fileName =
        prefixFile +
        shortid.generate() +
        (originalFileName.length > 20
          ? originalFileName.substr(0, 20)
          : originalFileName);
      // const encodedFile = await getBase64(file);
      const attachmentFile = {
        Name: fileName,
        // Body: encodedFile.split(',')[1],
        fileData: window.URL.createObjectURL(file),
        parentId: "",
        ContentType: file.type,
      };
      attachment[names[1]] = attachment[names[1]] || {};
      attachment[names[1]] = {
        ...attachment[names[1]],
        [names[0]]: attachmentFile,
      };
      this.setState({ attachment });
    }
  }

  onRemoveFile(name, index) {
    const { attachment } = this.state;
    delete attachment[index][name];
    this.setState({ attachment });
  }

//   onBlurValidation(e, fieldName){
//     const { form } = this.state;
//      if (fieldName === "No_of_Receipts_Approved__c") {
//         console.log("111")
//       if (e.target.value > 12) {
//         const { name, value } = e.target;
//         const names = name.split(".");
//         form[names[1]] = form[names[1]] || {};
//         form[names[1]][names[0]] = value;
//         this.validateInputArray(this.validationBlurList(names[1]), false, names[1]);
//       }
//     } 
//   }

//   validationBlurList(){
//     console.log("222")
//     return{
//     No_of_Receipts_Approved__c: {
//         validate: val => val > 12, message: 'Must be less then 12'
//     }
//     }
//   }

  onInputChanged(e, fieldName = null, index = 0) {
    const { form } = this.state;

    if (fieldName === "No_of_Receipts_Approved__c") {
    //   if (e.target.value <= 12) {
        const { name, value } = e.target;
        const names = name.split(".");
        form[names[1]] = form[names[1]] || {};
        form[names[1]][names[0]] = value;
        this.validateInputArray(this.validationList(names[1]), false, names[1]);
    //   }else if(e.target.value > 12){
    //     console.log(this.state.errorMessage, "erorrrrrrr")
    //   }
    } 

else {
      if (fieldName) {
        if (moment.isMoment(e)) {
          form[index][fieldName] = e;
        } else {
          form[index][fieldName] = e;
        }
      } else {
        const { name, value } = e.target;
        const names = name.split(".");
        form[names[1]] = form[names[1]] || {};
        form[names[1]][names[0]] = value;
        this.validateInputArray(this.validationList(names[1]), false, names[1]);
      }
    }
    this.setState({ form });
  }

  validationList(checkedIndex = 0) {
    const { form } = this.state;
    return {
      Full_Name__c: { validate: (val) => !isEmpty(val || "") },
      ID_Number__c: {
        message: "Invalid FIN or NRIC",
        validate: (val) => validateNRIC(val || ""),
      },
      Email_Address__c: {
        message: "Invalid email",
        validate: (val) => isEmail(val || "") || !isEmpty(val || ""),
      },
      Date_of_Birth__c: {
        validate: (val) => !isEmpty(val ? val.toString() : ""),
      },
      // Gender__c: { validate: val => !isEmpty(val || '') },
      // Race__c: { validate: val => !isEmpty(val || '') },
      // Other_Race__c: {
      //     validate: (val) => {
      //         if (form[checkedIndex].Race__c === 'Others') {
      //             return !isEmpty(val || '');
      //         }
      //         return true;
      //     },
      // },
      Nationality__c: { validate: (val) => !isEmpty(val || "") },
      // Other_Nationality__c: {
      //     validate: (val) => {
      //         if (form[checkedIndex].Nationality__c === 'Singaporean PR') {
      //             return !isEmpty(val || '');
      //         }
      //         return true;
      //     },
      // },
      Current_School__c: { validate: (val) => !isEmpty(val || "") },
      Current_Level__c: { validate: (val) => !isEmpty(val || "") },
      // Relationship_to_Applicant__c: { validate: val => !isEmpty(val || '') },
      // Other_Relationship__c: {
      //     validate: (val) => {
      //         if (form[checkedIndex].Relationship_to_Applicant__c === 'Others') {
      //             return !isEmpty(val || '');
      //         }
      //         return true;
      //     },
      // },
      Payout_Start__c: {
        validate: (val) => moment.isMoment(val) || !isEmpty(val || ""),
      },
      No_of_Receipts_Approved__c: {
        validate: val => isNumeric(val || ''), message: 'Must be a number'
        // validate: (val) => {
        //     console.log(val, "val")
        //     if (isNumeric(val) > 12) {
        //     console.log(val, "val12")
        //     return "Must be less than or equal to 12";
        //   }
        //   if (!isNumeric(val)) {
        //     return "Must be a number";
        //   }          
        // },
      },
   
    };
  }

  removeBeneficiary(beneficiaryIndex) {
    const { form: beneficiary } = this.state;
    swal
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      })
      .then((result) => {
        if (result.value) {
          beneficiary.splice(beneficiaryIndex, 1);
          this.setState({ beneficiary });
        }
      });
  }

  render() {
    const { form, errorMessage } = this.state;
    console.log(form, "formmmm")
    return (
      <div className="col-md-12 print" id="tab3">
        <br />
        <h4 className="info-text"> Beneficiaries List</h4>
        {form.map((bene, index) => (
          <div className="full">
            <div className="row">
              <div className="col-sm-6">
                <p>Beneficiary - {index + 1} </p>
              </div>
              <div className="col-sm-6 right">
                <button
                  className="small"
                  onClick={() => this.removeBeneficiary(index)}
                >
                  <i className="fa fa-minus" />
                </button>
              </div>
            </div>
            <BeneficiaryForm
              form={bene}
              onInputChanged={this.onInputChanged}
            //   onBlurValidation={this.onBlurValidation}
              errorMessage={errorMessage[index] || {}}
              onFileUploaded={this.onFileUploaded}
              index={index}
              shortid={shortid()}
              attachment={this.state.attachment[index] || {}}
              objectInfo={this.props.objectInfo}
              onRemoveFile={this.onRemoveFile}
            />
          </div>
        ))}
        <div className="row">
          <div className="text-center col-lg-12">
            <button
              className="btn btn-md btn-primary"
              onClick={() => {
                form[form.length] = { shortid: shortid() };
                this.setState({ form });
              }}
            >
              <i className="fa fa-plus" />
              Add More Beneficiary
            </button>
          </div>
        </div>
        <div className="text-center">
          <div className="btn-group">
            <Link
              to="/step-1"
              key="prev-tab2"
              className="btn btn-md btn-warning btn-fill "
              onClick={() => {
                window.scrollTo({ top: 0 });
              }}
            >
              <i className="fa fa-arrow-left" />
              Previous
            </Link>
            <a
              href={null}
              type="reset"
              className="btn btn-info btn-fill"
              onClick={this.props.resetRegistration}
            >
              <i className="fa fa-refresh" /> Clear Form
            </a>
            <a
              href={null}
              className="btn btn-md btn-inverse btn-fill "
              onClick={(e) => {
                document.querySelector(".main-panel").scrollTop = 300;
                const isPassed = this.validateInputArray(
                  this.validationList,
                  true
                );

                if (!isPassed) {
                  e.preventDefault();
                  swal.fire({
                    title: "Incomplete form",
                    text: "Please validate all data before saving.",
                    type: "warning",
                  });
                } else {
                  this.props.updateRegistrationData("3", this.state.form);
                  this.props.updateAttachment("3", this.state.attachment);
                  this.props.saveAsDraft();
                }
              }}
            >
              <i className="fa fa-save" />
              Save as Draft
            </a>
            <Link
              to="/step-3"
              key="next-tab2"
              className="btn btn-md  btn-primary btn-fill"
              onClick={(e) => {
                // e.preventDefault();
                document.querySelector(".main-panel").scrollTop = 300;
                const isPassed = this.validateInputArray(
                  this.validationList,
                  true
                );
                if (!isPassed) e.preventDefault();
                else {
                  this.props.updateAttachment("3", this.state.attachment);
                  this.props.updateRegistrationData("3", this.state.form);
                }
              }}
            >
              Next
              <i className="fa fa-arrow-right" />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

Tab3.propTypes = {
  changeStep: PropTypes.func.isRequired,
  objectInfo: PropTypes.object.isRequired,
  updateRegistrationData: PropTypes.func.isRequired,
  resetRegistration: PropTypes.func.isRequired,
  tab2: PropTypes.object.isRequired,
  tab3: PropTypes.object.isRequired,
  recordType: PropTypes.object.isRequired,
  saveAsDraft: PropTypes.func.isRequired,
  updateAttachment: PropTypes.func.isRequired,
  attachment: PropTypes.array.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeStep,
      updateRegistrationData,
      resetRegistration,
      saveAsDraft,
      updateAttachment,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  user: state.user,
  currentStep: state.registration.currentStep,
  objectInfo: state.objectInfo,
  tab3: state.registration.tab3,
  tab2: state.registration.tab2,
  attachment: state.registration.attachment.tab3,
  recordType: state.salesforce.recordType,
});

export default connect(mapStateToProps, mapDispatchToProps)(Tab3);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/Tab3/index.js
// module id = 1014
// module chunks = 0